import { Fuel } from 'lucide-react';

export const LoadingState = () => {
  return (
    <div 
      data-testid="loading-state"
      className="flex flex-col items-center justify-center py-20 px-4"
    >
      {/* Square loading animation with progress bar around */}
      <div className="relative w-28 h-28">
        {/* SVG for animated border */}
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100">
          {/* Background rectangle */}
          <rect
            x="2"
            y="2"
            width="96"
            height="96"
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            className="text-gray-200 dark:text-gray-700"
          />
          {/* Animated progress rectangle */}
          <rect
            x="2"
            y="2"
            width="96"
            height="96"
            fill="none"
            stroke="#FF4500"
            strokeWidth="4"
            strokeDasharray="384"
            strokeDashoffset="384"
            className="loading-rect"
          />
        </svg>
        
        {/* Inner logo container */}
        <div className="absolute inset-2 bg-white dark:bg-[#111] flex items-center justify-center">
          <Fuel className="w-12 h-12 text-[#FF4500]" />
        </div>
      </div>
      
      <p className="mt-8 font-heading text-2xl font-bold uppercase text-black dark:text-white tracking-wider">
        Chargement
      </p>
      <div className="mt-3 flex gap-1.5">
        <span className="w-2 h-2 bg-[#FF4500] animate-bounce" style={{ animationDelay: '0ms' }} />
        <span className="w-2 h-2 bg-[#FF4500] animate-bounce" style={{ animationDelay: '150ms' }} />
        <span className="w-2 h-2 bg-[#FF4500] animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  );
};
